.root {
  /* copied from bootstrap */
  &:global(.is-valid) > div,
  &:global(.is-invalid) > div {
    padding-right: calc(1.5em + 0.75rem);
    background-repeat: no-repeat;
    background-position: right calc(0.375em + 0.1875rem) center;
    background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
  }

  &:global(.is-invalid) > div {
    background-image: url("@/assets/icons/exclamation-red.svg");
    border-color: var(--sentiment-negative);
  }

  &:global(.is-valid) > div {
    background-image: url("@/assets/icons/check-green.svg");
    border-color: var(--sentiment-positive);
  }
}
